import type { ReactNode } from 'react'
import { Button } from 'uikit/buttons/default'
import styles from './controls.module.scss'

interface GraphMessageStateProps {
  icon: ReactNode
  message: string
  onClose: () => void
}

export function GraphMessageState({ icon, message, onClose }: GraphMessageStateProps) {
  return (
    <div className={styles.messageContainer}>
      <span className={styles.messageIcon}>{icon}</span>
      <span>{message}</span>
      <div className={styles.messageActions}>
        <Button type='primary' onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  )
}
